import { Component, JSX } from 'solid-js'

import './style/addbtn.scss'

interface AddBtnProps {
    title: string
    icon?: JSX.Element

    onClick(): void

    class?: string
}

export const AddBtn: Component<AddBtnProps> = P => {
    return (
        <div onclick={P.onClick} class={`add-btn-cmp ${P.class}`} role='button'>
            {P.title}
            {P.icon}
        </div>
    )
}
